import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import { Button, Grid } from "@mui/material";
import "./DataGridTamplet.scss";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

const DataGridTamplet = ({
  columns,
  rows,
  filters = null,
  onSearch = null,
  textFieldLabel = null,
  selectedFiltersValues = null,
  setSelectedFiltersValues = null,
  children = null,
  height = null,
  filterInClientSide = true
}) => {
  const { t } = useTranslation("dataGridTemplet");
  const [filteredRows, setfilteredRows] = React.useState([]);

  useEffect(() => {
    if (rows) {
      setfilteredRows(rows);
      if (selectedFiltersValues && checkHasFilters() && filterInClientSide) {
        search();
      }
    }
  }, [rows]);

  const checkHasFilters = () => {
    return Object.values(selectedFiltersValues).some(val => val !== null && val !== '');
  }

  const handleChange = (event, filterId) => {
    setSelectedFiltersValues({
      ...selectedFiltersValues,
      [filterId]: event.target.value as string,
    });
  };

  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFiltersValues({
      ...selectedFiltersValues,
      ["fieldText"]: event.target.value as string,
    });
    doSearch(event.target.value);
  };

  const doSearch = (fieldText) => {
    if (filterInClientSide) {
      setfilteredRows(onSearch(rows, fieldText));
    } else {
      onSearch(rows, fieldText);
    }
  };

  const search = () => {
    doSearch(selectedFiltersValues['fieldText']);
  };

  const resetFilters = () => {
    Object.keys(selectedFiltersValues).forEach(
      (key) => (selectedFiltersValues[key] = key !== "history" ? "" : selectedFiltersValues[key])
    );
    setSelectedFiltersValues({ ...selectedFiltersValues });
    setfilteredRows(rows);
  };

  return (
    <Box p={3} className="wrap-page">
      <Box sx={{display: "flex", justifyContent: "end"}}>{children}</Box>
      <Grid container spacing={3} mb={2} mt={1}>
        {selectedFiltersValues && (
          <Grid item xs={3}>
            <TextField
              id="outlined-basic"
              label={textFieldLabel}
              variant="outlined"
              onChange={handleChangeInput}
              className="search-input"
              value={selectedFiltersValues["fieldText"] || ""}
            />
          </Grid>
        )}
        {filters &&
          filters.map((item) => (
            <Grid item xs={3} key={item.name}>
              <TextField
                id="outlined-select-currency"
                select
                label={item.name}
                value={selectedFiltersValues[item.id] || ""}
                onChange={(event) => handleChange(event, item.id)}
              >
                {item.values.map((value, index) => (
                  <MenuItem key={index} value={value.value}>
                    {value.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          ))}
        {filters && (
          <Grid item xs={3} sx={{ display: "flex", alignItems: "center" }}>
            <Button
              className="blue-btn"
              type="submit"
              onClick={search}
            >
              {t("search")}
            </Button>
            <Button
              variant="text"
              size="small"
              className="reset-btn"
              type="submit"
              onClick={resetFilters}
            >
              {t("reset_filters")}
            </Button>
          </Grid>
        )}
      </Grid>
      <Box sx={{ height: () => (height? height: 600), width: "100%" }}>
        <DataGrid rows={filteredRows} columns={columns} />
      </Box>
    </Box>
  );
};
export default DataGridTamplet;
